module.exports = __webpack_public_path__ + "static/media/shell32_156.9362af07.ico";